
import Experience from './Experience/Experience.js'

const settings = {
    width: 240,
    height: 220,
    depth: 60,
    bays: 3,
    shelves: 3,
    drawers: 2,
    rods: true,
    doors: 'open',
    finish: 'oak'
}

window.wardrobeSettings = settings

const controls = document.querySelectorAll('[data-setting]')
const valueLabels = document.querySelectorAll('[data-value-for]')
const derivedBays = document.querySelector('[data-derived="bays"]')
const derivedShelves = document.querySelector('[data-derived="shelves"]')
const footprint = document.querySelector('[data-summary="footprint"]')
const layout = document.querySelector('[data-summary="layout"]')
const area = document.querySelector('[data-summary="area"]')
const baseRate = document.querySelector('[data-summary="base-rate"]')
const doorRate = document.querySelector('[data-summary="door-rate"]')
const price = document.querySelector('[data-summary="price"]')
const priceBadge = document.querySelector('[data-price-badge]')

const maxBayWidth = 80
const maxShelfGap = 50
const drawerHeight = 22
const structuralAllowance = 30
const cmPerFoot = 30.48
const basePricePerSqft = 1500
const doorPricePerSqft = {
    open: 0,
    hinged: 250,
    sliding: 450,
    glass: 850
}
const numericSettings = new Set(['width', 'height', 'depth', 'drawers'])
const rupeeFormatter = new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0,
    style: 'currency',
    currency: 'INR'
})

function deriveBayCount(width)
{
    return Math.max(1, Math.ceil(width / maxBayWidth))
}

function deriveShelfCount(height, drawers)
{
    const doorHeight = Math.max(maxShelfGap, height - drawers * drawerHeight - structuralAllowance)
    const compartments = Math.max(1, Math.ceil(doorHeight / maxShelfGap))

    return Math.max(0, compartments - 1)
}

function calculatePricing()
{
    const areaSqft = (settings.width / cmPerFoot) * (settings.height / cmPerFoot)
    const doorRatePerSqft = doorPricePerSqft[settings.doors] || 0
    const totalRate = basePricePerSqft + doorRatePerSqft
    const total = areaSqft * totalRate

    return {
        areaSqft,
        doorRatePerSqft,
        total
    }
}

function readControl(control)
{
    if(control.type === 'checkbox')
        return control.checked

    if(numericSettings.has(control.dataset.setting))
        return Number(control.value)

    return control.value
}

function syncLabels()
{
    settings.bays = deriveBayCount(settings.width)
    settings.shelves = deriveShelfCount(settings.height, settings.drawers)

    valueLabels.forEach((label) =>
    {
        const key = label.dataset.valueFor
        label.textContent = `${settings[key]} cm`
    })

    derivedBays.textContent = `${settings.bays} auto`
    derivedShelves.textContent = `${settings.shelves} auto`
    footprint.textContent = `${settings.width} x ${settings.depth} cm`
    layout.textContent = `${settings.bays} bays, ${settings.shelves} shelves`

    const pricing = calculatePricing()
    area.textContent = `${pricing.areaSqft.toFixed(1)} sqft`
    baseRate.textContent = `${rupeeFormatter.format(basePricePerSqft)}/sqft`
    doorRate.textContent = `${rupeeFormatter.format(pricing.doorRatePerSqft)}/sqft`
    price.textContent = rupeeFormatter.format(pricing.total)
    priceBadge.textContent = rupeeFormatter.format(pricing.total)
}

function updateSetting(control)
{
    settings[control.dataset.setting] = readControl(control)
    syncLabels()
    window.dispatchEvent(new CustomEvent('wardrobe:update', { detail: settings }))
}

controls.forEach((control) =>
{
    control.addEventListener('input', () => updateSetting(control))
    control.addEventListener('change', () => updateSetting(control))
})

syncLabels()

const experience = new Experience(document.querySelector('canvas.webgl'))
